/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class BlankCardView extends Component {

	render() {
		const { classPrefix } = this.props;
		const className = classNames(classPrefix, `${classPrefix}--blank`);
		return (
			<div className={className}>
				{this.props.children}
			</div>
		);
	}
}

BlankCardView.propTypes = {
	children: PropTypes.any,
	classPrefix: PropTypes.string
};

BlankCardView.defaultProps = {
	classPrefix: 'cardThumbnails__item'
};

export default BlankCardView;



// WEBPACK FOOTER //
// ./src/js/components/cards/views/BlankCardView.js